const updates = [
  { date: '07-28', title: '《修仙狂徒》第342话更新', tag: '国漫', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '《暗夜猎手》第89话更新', tag: '韩漫', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-27', title: '《星海迷途》新作上架，全篇免费', tag: '日漫', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-27', title: '《甜蜜陷阱》第156话更新', tag: '条漫', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: '《武道至尊》第520话里程碑', tag: '国漫', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: '《恶魔的契约》第三季开更', tag: '韩漫', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-25', title: '《异世界食堂》番外篇上线', tag: '日漫', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-25', title: '《总裁的替身新娘》第88话', tag: '条漫', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-24', title: '《灵笼》特别篇全网首发', tag: '国漫', tagColor: 'bg-primary-100 text-primary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/70 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-timer-line"></i>
            快讯
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">最新动态</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            每日同步更新热门连载，精彩内容不错过
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 py-4 ${
                i < updates.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <span className="text-xs md:text-sm font-mono text-foreground-400 whitespace-nowrap w-12">{item.date}</span>
              <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${item.tagColor}`}>
                {item.tag}
              </span>
              <span className="text-sm md:text-base text-foreground-800 flex-1">{item.title}</span>
              <span className="text-accent-500 text-xs font-medium whitespace-nowrap hidden sm:inline">NEW</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}